import { render, staticRenderFns } from "./ContentHome.vue?vue&type=template&id=e506cd1c&"
import script from "./ContentHome.vue?vue&type=script&lang=js&"
export * from "./ContentHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports